module.exports = __webpack_public_path__ + "static/media/oliz.c2fc339a.png";